import Dialog from "@mui/material/Dialog";
import {
  Box,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";
import DownloadIcon from "@mui/icons-material/Download";

const imageExtensions = [
  ".jpg",
  ".jpeg",
  ".png",
  ".bmp",
  ".tiff",
  ".tif",

  ".ico",
  ".heic",
  ".heif",
  ".raw",
  ".cr2",
  ".nef",
  ".orf",
  ".sr2",
];

const containsImageExtension = (filename, allowedImagesExtensions) => {
  return allowedImagesExtensions.some((ext) =>
    filename.toLowerCase().endsWith(ext)
  );
};

const PreviewAttachmentDialog = ({
  open,
  handleClose,
  attachmentDetails,
  providedImagesExtensions,
}) => {
  // Support two modes:
  // 1. URL mode: { url, fileName } — displays directly without fetching (fast)
  // 2. File mode: { fileObject } — uses blob URL (for local file inputs)
  const { fileObject, url: directUrl, fileName: directFileName } = attachmentDetails;

  const fileName = fileObject ? fileObject.name : directFileName || "";

  const isImageAttachment = containsImageExtension(
    fileName,
    providedImagesExtensions || imageExtensions
  );
  const isPdfAttachment = fileName.toLowerCase().endsWith(".pdf");

  // Get the display URL — use direct URL if available, otherwise create blob URL
  const previewUrl = directUrl || (fileObject ? URL.createObjectURL(fileObject) : "");

  const handleDownloadClick = () => {
    const link = document.createElement("a");
    link.href = previewUrl;
    link.download = fileName;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Dialog
      open={open}
      maxWidth="md"
      fullWidth
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        sx={{ justifyContent: "space-between", display: "flex" }}
        id="customized-dialog-title"
      >
        <Typography
          component="div"
          sx={{ fontWeight: "bold", fontSize: "1.25rem" }}
        >
          Attachment Preview
        </Typography>
        <IconButton aria-label="close" onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Stack justifyContent="center" alignItems="center">
          {isImageAttachment ? (
            <img
              src={previewUrl}
              style={{ maxWidth: 500, maxHeight: 500 }}
              alt="preview"
            />
          ) : isPdfAttachment ? (
            <embed
              src={previewUrl}
              type="application/pdf"
              width="100%"
              height="500px"
            />
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Stack direction={"row"} gap={3}>
                <Typography>File Name:</Typography>
                <Typography component="div">{fileName}</Typography>
              </Stack>
              <IconButton onClick={handleDownloadClick}>
                <DownloadIcon color={"primary"} />
              </IconButton>
            </Box>
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default PreviewAttachmentDialog;
